import _ from 'lodash';

import { commonErrors } from '@zapier/toolbox-redux-framework/src/error';

import * as statuses from './statuses';

const createState = state => ({
  status: statuses.INITIAL,
  ...(state || {}),
});

export const generateEntityCid = () => _.uniqueId('entity-');

export const createEntity = (id, data, state) => {
  const { cid, ...cleanData } = data || {};
  return {
    cid: cid || generateEntityCid(),
    data: { ...cleanData, id },
    state: createState(state),
  };
};

export const createCollection = (entities, state, data) => ({
  entities: { ...(entities || {}) },
  state: createState(state),
  data: data || {},
});

export const formatSuccess = (messages, entity) => ({
  entity,
  status: statuses.SUCCESS,
  messages: _.get(messages, 'success'),
});

export const remove401StatusFromGetErrorResponse = (entityType, response) => {
  throw response.status === 401
    ? new commonErrors.DataGetError({
        resource: entityType,
        // Have to strip `status` from `response` to prevent
        // `autoPromiseMiddleware` from redirecting based on 401
        response: { ...response, status: null },
      })
    : response;
};
